export enum FeatureFlags {
    ReserveAccessories = 'RESERVE_ACCESSORIES',
    DeviceProtectionPlan = 'DEVICE_PROTECTION_PLAN',
    InstantInterview = 'INSTANT_INTERVIEW',
    BookAppointment = 'BOOK_APPOINTMENT',
    PrivacyPolicyUpdate = 'PRIVACY_POLICY_UPDATE',
    BannerTradeInPage = 'BANNER_TRADEIN_PAGE',
    DualPricing = 'PHONES_DUAL_PRICING',
    NavigationActivePage = 'NAVIGATION_ACTIVE_PAGE'
  }

export enum VariantNames {
  WithActiveState = 'WITH_ACTIVE_STATE'
}
